import * as api from './api';
import modules from './storeModules';

// wallet模块通用接口和方法
export default {
  ...api,
  modules,
};
